import { render, staticRenderFns } from "./SaleingRatePlan.vue?vue&type=template&id=09ede94f&scoped=true"
import script from "./SaleingRatePlan.vue?vue&type=script&lang=js"
export * from "./SaleingRatePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ede94f",
  null
  
)

export default component.exports